module.exports = __webpack_public_path__ + "img/card-bg-image-demo-2.720ceb82.jpg";